import React from 'react';
import PropTypes from 'prop-types';
import appOrangeIcon from 'assets/images/icons/app-screen-orange.svg';
import checkCircleBlueIcon from 'assets/images/icons/check-circle-broken-blue.svg';
import lockOrangeIcon from 'assets/images/icons/lock-orange.svg';
import AlertModal from 'components/common-components/AlertModal';

const SupervisorLockedModal = ({
  showSupervisorLockedModal,
  setShowSupervisorLockedModal,
  isNestedModal,
}) => {
  return (
    <AlertModal
      show={!!showSupervisorLockedModal}
      closeModal={() => setShowSupervisorLockedModal(null)}
      actionButtons={[]}
      backdropClassName={isNestedModal ? 'backdrop-overlap' : ''}
    >
      <div className='d-flex gap-4 flex-column align-items-center px-4'>
        <div className='d-flex align-items-center gap-1'>
          <img
            src={
              showSupervisorLockedModal === 'user'
                ? appOrangeIcon
                : showSupervisorLockedModal === 'section'
                ? lockOrangeIcon
                : checkCircleBlueIcon
            }
          />
          <label
            className={`theme-size-1_2 ${
              showSupervisorLockedModal === 'end' ? 'theme-text-blue-1' : 'theme-text-orange-1'
            }`}
          >
            {showSupervisorLockedModal === 'user'
              ? 'App User'
              : showSupervisorLockedModal === 'section'
              ? 'Locked'
              : 'Ended'}
          </label>
        </div>

        {showSupervisorLockedModal === 'user' ? (
          <label>
            This section cannot be submitted while the form is in <strong>App User Status.</strong>
          </label>
        ) : showSupervisorLockedModal === 'section' ? (
          <label>
            {/* <strong>Note!</strong> This section is currently locked as another manager is completing
            their part, and the workflow has not progressed to this section. */}
            {`You don't have permission to fill Manager Section.`}
          </label>
        ) : (
          <label>
            <strong>The workflow is complete.</strong>{' '}
            {`Manager sections are read-only and can't be edited or submitted.`}
          </label>
        )}

        <label
          className='theme-size-1_2 cursor-pointer'
          onClick={() => setShowSupervisorLockedModal(null)}
        >
          <strong>Close</strong>
        </label>
      </div>
    </AlertModal>
  );
};

SupervisorLockedModal.propTypes = {
  showSupervisorLockedModal: PropTypes.string,
  setShowSupervisorLockedModal: PropTypes.func.isRequired,
  isNestedModal: PropTypes.bool,
};

export default SupervisorLockedModal;
